/* =========================================
   GamingPCWorld - VS Exclusive Offers
   File: assets/vs-exclusive-offers.js
========================================= */

(function () {
  'use strict';

  /*
   * Prevent duplicate event listeners if the script
   * is accidentally loaded more than once.
   */
  if (window.vsExclusiveOffersInitialized) {
    return;
  }

  window.vsExclusiveOffersInitialized = true;

  /*
   * Get the Shopify root URL safely.
   */
  function getShopifyRoot() {
    if (
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
    ) {
      return window.Shopify.routes.root;
    }

    return '/';
  }

  /*
   * Add selected product variant to cart.
   */
  async function addProductToCart(button) {
    var section = button.closest('[data-vs-offers]');

    if (!section) {
      return;
    }

    var variantId = button.getAttribute('data-variant-id');
    var quantity = parseInt(
      button.getAttribute('data-quantity') || '1',
      10
    );

    var status = section.querySelector('[data-vs-cart-status]');
    var originalHTML = button.innerHTML;

    if (!variantId || button.disabled) {
      return;
    }

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.innerHTML = '<span>Adding...</span>';

    if (status) {
      status.textContent = '';
    }

    try {
      var response = await fetch(getShopifyRoot() + 'cart/add.js', {
        method: 'POST',

        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },

        body: JSON.stringify({
          items: [
            {
              id: Number(variantId),
              quantity: Math.max(1, quantity)
            }
          ]
        })
      });

      var result = await response.json();

      if (!response.ok) {
        throw new Error(
          result.description ||
          result.message ||
          'Unable to add the product to your cart.'
        );
      }

      button.innerHTML = '<span>Added to Cart ✓</span>';

      if (status) {
        status.textContent = 'Product added to your cart.';
      }

      /*
       * Trigger a custom event for themes or apps
       * that listen for cart updates.
       */
      document.dispatchEvent(
        new CustomEvent('vs:cart:updated', {
          detail: {
            item: result,
            variantId: variantId
          }
        })
      );

      /*
       * Navigate to the cart so customers can review
       * their newly added item.
       */
      window.location.href = getShopifyRoot() + 'cart';

    } catch (error) {
      button.innerHTML = originalHTML;
      button.disabled = false;
      button.removeAttribute('aria-busy');

      if (status) {
        status.textContent =
          error.message ||
          'Something went wrong. Please try again.';
      }

      console.error(
        '[VS Exclusive Offers] Add to cart failed:',
        error
      );
    }
  }

  /*
   * Delegated click handling supports multiple
   * offer sections on the same page.
   */
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-vs-add-to-cart]');

    if (!button) {
      return;
    }

    event.preventDefault();
    addProductToCart(button);
  });

})();